<template>
  <v-menu
    v-if="resumen.facturas.length"
    offset-y
    style="border-radius: 20px !important;"
    bottom
    :close-on-content-click="false"
    open-on-click
  >
    <template v-slot:activator="{ on, attrs }">
      <div
        class="calendar-day"
        :class="{ 'not-current': !isCurrentMonth }"
        style="display: flex; flex-direction: column; align-items: center; justify-content: space-between;"
        v-bind="attrs"
        v-on="on"
      >
        <div class="date-label" :class="{ today: isToday }">
          <span v-if="isFirstOfMonth">
            {{ moment(date).format('MMM D') }}
          </span>
          <span v-else>
            {{ moment(date).date() }}
          </span>
        </div>

        <div class="facturas-resumen mt-2">
          <div class="facturas-cantidad" style="text-align: center;">
            {{ resumen.cantidad }} factura{{ resumen.cantidad > 1 ? 's' : '' }}
          </div>
          <div class="facturas-monto">
            ${{ formatMoney(resumen.monto) }} USD
          </div>
        </div>
      </div>
    </template>

    <v-card style="min-width: 280px;">
      <v-list dense>
        <template v-for="(factura, index) in resumen.facturas">
          <v-list-item :key="'item-' + factura.id">
            <v-list-item-content>
              <div style="font-weight: bold;">#{{ factura.folio }} {{ factura.cliente }}</div>
              <div class="mt-2" style="width: fit-content;">
                <v-chip
                  :color="colorPorEstado(factura.estado)"
                  text-color="white"
                  class="text-caption font-weight-medium"
                  style="border-radius: 8px;"
                  small
                  label
                >
                  {{ capitalize(factura.estado) }}
                </v-chip>
              </div>
            </v-list-item-content>
            <v-list-item-action>
              <div class="text-right">
                <div style="font-weight: bold;">${{ formatMoney(factura.monto) }} USD</div>
                <v-btn small icon @click="goToFactura(factura.id)">
                  <v-icon small>mdi-arrow-right</v-icon>
                </v-btn>
              </div>
            </v-list-item-action>
          </v-list-item>
          <v-divider v-if="index < resumen.facturas.length - 1" :key="'divider-' + index" class="mx-2"></v-divider>
        </template>
      </v-list>
    </v-card>
  </v-menu>

  <div
    v-else
    class="calendar-day"
    :class="{ 'not-current': !isCurrentMonth }"
    style="display: flex; flex-direction: column; align-items: center; justify-content: space-between;"
  >
    <div class="date-label" :class="{ today: isToday }">
      <span v-if="isFirstOfMonth">
        {{ moment(date).format('MMM D') }}
      </span>
      <span v-else>
        {{ moment(date).date() }}
      </span>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  props: {
    date: String, // 'YYYY-MM-DD'
    facturas: Array,
    isCurrentMonth: Boolean
  },
  computed: {
    resumen() {
      const currentDate = moment(this.date).format('YYYY-MM-DD')
      const delDia = this.facturas.filter(f =>
        moment(f.fecha_vencimiento).format('YYYY-MM-DD') === currentDate
      )
      const total = delDia.reduce((sum, f) => sum + f.monto, 0)

      return {
        cantidad: delDia.length,
        monto: total,
        facturas: delDia
      }
    },
    isToday() {
      return moment().isSame(this.date, 'day')
    },
    isFirstOfMonth() {
      return moment(this.date).date() === 1
    }
  },
  methods: {
    colorPorEstado(estado) {
      switch (estado) {
        case 'adelantar': return 'orange darken-2'
        case 'cobrar': return 'green darken-2'
        case 'liquidar': return 'blue darken-2'
        default: return 'grey'
      }
    },
    capitalize(text) {
      if (!text) return ''
      return text.charAt(0).toUpperCase() + text.slice(1)
    },
    formatMoney(value) {
      return new Intl.NumberFormat('en-US', {
        style: 'decimal',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(value)
    },
    capitalize(text) {
      return text.charAt(0).toUpperCase() + text.slice(1)
    },
    goToFactura(id) {
      // Aquí iría la lógica de navegación, puedes ajustar según uses Vue Router
      this.$router.push(`/facturas/${id}`)
    },
    moment
  }
}
</script>

<style scoped>
.calendar-day {
  border-right: 1px solid #e0e0e0;
  border-bottom: 1px solid #e0e0e0;
  min-height: 90px;
  padding: 8px;
  font-size: 13px;
}
.not-current {
  background-color: #f9f9f9;
  color: #999;
}
.date-label {
  font-weight: 600;
}
.today {
  background: #eee;
  border-radius: 50%;
  padding: 4px 8px;
}
.facturas-resumen {
  font-size: 12px;
  margin-top: 4px;
}
.facturas-cantidad {
  font-weight: bold;
}
.facturas-monto {
  color: #444;
}
.v-menu__content {
  border-radius: 20px !important;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.7);
}
</style>
